'use client';

import { useEffect, useState } from 'react';

// The virtual keyboard shrinks the visual viewport without changing the layout viewport (`100dvh` stays the same),
// so the gap between the two is both the signal that the keyboard is open and its height. The threshold keeps
// browser chrome (a collapsing URL bar) from reading as a keyboard.
const keyboardHeightThreshold = 150;

/**
 * Tracks the on-screen keyboard via the visual viewport. `keyboardHeight` is the space the keyboard covers at the
 * bottom of the window, so a full-height panel can reserve it and keep its content reachable.
 */
const useIsVirtualKeyboardOpen = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return undefined;
    }

    const onViewportResize = () => {
      const coveredHeight = window.innerHeight - viewport.height;
      setKeyboardHeight(coveredHeight > keyboardHeightThreshold ? coveredHeight : 0);
    };

    onViewportResize();
    viewport.addEventListener('resize', onViewportResize);
    return () => viewport.removeEventListener('resize', onViewportResize);
  }, []);

  return { isKeyboardOpen: keyboardHeight > 0, keyboardHeight };
};

export default useIsVirtualKeyboardOpen;
